import React from "react";
import { PanelAddAdSubCategory } from "../../../UI/AdSubCategories/Add/PanelAddSubCategory";

const AddAdSubCategory = () => {
  return (
    <div>
      <PanelAddAdSubCategory />
    </div>
  );
};

export default AddAdSubCategory;
